import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2, ChevronRight } from "lucide-react";
import { attentionAction, attentionItems } from "./workspaceOverviewModel";

export default function WorkspaceAttentionCard({ overview }) {
  const items = attentionItems(overview);
  const action = attentionAction(items);
  const quiet = items.length === 0;

  return (
    <section className="rr-panel-card" aria-labelledby="attention-title">
      <header>
        <h2 id="attention-title">
          {quiet ? <CheckCircle2 size={18} aria-hidden="true" /> : <AlertTriangle size={18} aria-hidden="true" />}
          {quiet ? "Nothing needs your attention" : "Needs your attention"}
        </h2>
        {action ? <ChevronRight size={16} aria-hidden="true" /> : null}
      </header>
      {quiet ? <p>RenderRepo is watching for product drift.</p> : (
        <ul>
          {items.map((item) => (
            <li key={item.id}>
              {item.href.startsWith("#") ? <a href={item.href}>{item.label}</a> : <Link to={item.href}>{item.label}</Link>}
            </li>
          ))}
        </ul>
      )}
      {action && !action.href.startsWith("#") ? <Link className="rr-button secondary" to={action.href}>{action.label}</Link> : null}
      {action && action.href.startsWith("#") ? <a className="rr-button secondary" href={action.href}>{action.label}</a> : null}
    </section>
  );
}
